import Vue from 'vue'
import TopNav from './topNav.vue'
import LbButton from './lbButton.vue'
import LbSwitch from './lbSwitch.vue'
import LbTips from './lbTips.vue'
import LbPage from './lbPage.vue'
import LbClassifyTitle from './lbClassifyTitle.vue'
import LbUpload from './lbUpload.vue'
import LbToolTips from './lbToolTips.vue'
import LbUploadCover from './lbUploadCover.vue'
import LbUeditor from './lbUeditor.vue'
import LbCover from './lbCover.vue'
import LbImage from './lbImage.vue'
import LbMap from './lbMap.vue'
import LBTemplate from './LBTemplate'
import LBMembers from './lbMembers'
Vue.component('lb-member', LBMembers)
Vue.component('lb-templte', LBTemplate)
Vue.component('top-nav', TopNav)
Vue.component('lb-button', LbButton)
Vue.component('lb-switch', LbSwitch)
Vue.component('lb-tips', LbTips)
Vue.component('lb-page', LbPage)
Vue.component('lb-classify-title', LbClassifyTitle)
Vue.component('lb-upload', LbUpload)
Vue.component('lb-tool-tips', LbToolTips)
Vue.component('lb-upload-cover', LbUploadCover)
Vue.component('lb-ueditor', LbUeditor)
Vue.component('lb-cover', LbCover)
Vue.component('lb-image', LbImage)
Vue.component('lb-map', LbMap)



// WEBPACK FOOTER //
// ./src/components/basics/index.js